import { render, staticRenderFns } from "./LoveGift.vue?vue&type=template&id=ab7542da&scoped=true&"
import script from "./LoveGift.vue?vue&type=script&lang=js&"
export * from "./LoveGift.vue?vue&type=script&lang=js&"
import style0 from "./LoveGift.vue?vue&type=style&index=0&id=ab7542da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7542da",
  null
  
)

export default component.exports